// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import navbar from "./navbar";
import signup from "./signup"
import googleTranslate from "./googleTranslate"

navbar();
signup()
googleTranslate()
